import useUpdateTicketFromVoucher from "./useUpdateTicketFromVoucher";
import {useAppSelector} from "@Hooks/selector/useAppSelector";

export default function useAddVoucher(voucherCode: string) {
    const {ticketCode} = useAppSelector((state) => state?.checkOrder.ticket)
    const params = {ticket_code: ticketCode, voucher_code: voucherCode};
    const updateTicket = useUpdateTicketFromVoucher('/ajax/apply-voucher', params)

    return () => updateTicket()
}